export default __webpack_public_path__ + "static/media/roadmap.c0a56440.md";